import React, { useState, useEffect, useRef, } from 'react';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { sumBy, isEmpty, sum, groupBy, get, keyBy, omit, mapValues, } from 'lodash';
import { useDebounce, useToggle, useList, } from 'react-use';
import { toast, } from 'react-toastify';
import jsbarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import { PDFDocument, } from 'pdf-lib';
import fileDownload from 'js-file-download';
import dedent from 'dedent';

import env from '../../env';
import { drawUnknownInventoryLabel, } from '../../label';
import okSoundSrc from '../../sounds/ok.mp3';
import ngSoundSrc from '../../sounds/ng.mp3';
import firebase, { functions } from '../../firebase';
import { batch } from '../../shared/firebase';
import { isMobile } from '../../util';
import useFormState from '../hooks/useFormState';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';
import Field from '../Field';
import { idWithTenant, } from '../../shared/util';
import ListForm from '../ListForm';
import PendingItemForm from '../forms/PendingItemForm';
import useCollectionFetch from '../hooks/useCollectionFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';

const labelWidth = 52.5;
const labelHeight = 29.7;
const { entries, keys, } = Object;
const db = firebase.firestore();
const unknownInventoriesRef = db.collection('unknownInventories');
const tenantsRef = db.collection('tenants');
const printBarcode = functions.httpsCallable('printBarcode');

export default function UnknownShelvingModal(props) {
  const { isOpen, tenants, locations, unknownReceivingRequest, } = props;
  const tenantsById = keyBy(tenants, 'id');
  const [isPrinting, togglePrinting] = useToggle(false);
  const [tenantNumber, setTenantNumber] = useState(unknownReceivingRequest?.ref.parent.parent.id.replace(env('TENANT_PREFIX'), '') || '');
  const [receivingRequestNumber, setReceivingRequestNumber] = useState(unknownReceivingRequest?.ref.id.replace('W', '') || '');
  const tenantId = tenantNumber && env('TENANT_PREFIX') + tenantNumber;
  const receivingRequestId = receivingRequestNumber && 'W' + receivingRequestNumber;
  const tenant = useDocumentSubscription(tenantId && tenantsRef.doc(tenantId), [tenantId]);
  const receivingRequest = useDocumentSubscription(tenant && receivingRequestId && tenant.ref.collection('receivingRequests').doc(receivingRequestId), [tenant, receivingRequestId]);
  const [quantity, setQuantity] = useState(unknownReceivingRequest != null ? sumBy(unknownReceivingRequest.pendingItems, 'quantity') : 1);
  const onClickClose = () => {
    props.onClickClose();
  };
  const onClickPrintBarcode = async () => {
    togglePrinting(true);
    try {
      const canvas = document.createElement('canvas');
      drawUnknownInventoryLabel(canvas, labelWidth, labelHeight, receivingRequest);
      const imageData = canvas.toDataURL('image/jpeg', 0.2);
      const doc = new jsPDF({
        orientation: 'landscape',
        format: [labelWidth, labelHeight]
      });
      doc.addImage(imageData, 'JPEG', 0, 0, labelWidth, labelHeight);
      const pdfData = doc.output('datauri');
      const allPdfDoc = await PDFDocument.create();
      const pdfDoc = await PDFDocument.load(pdfData);
      await Array(quantity).fill().reduce(async (x, _, i) => {
        await x;

        const [page] = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
        await allPdfDoc.addPage(page);
      }, Promise.resolve());

      const content = await allPdfDoc.saveAsBase64({ dataUri: true })
      // DEV
      // fileDownload(await allPdfDoc.save(), 'hoge.pdf');
      // return;

      await printBarcode({
        type: 'receivementProduct',
        title: receivingRequest.id,
        imageData: content,
      });
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
    togglePrinting(false);
  };

  return (
    <Modal isOpen={isOpen}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            不明ラベル発行
          </h5>
        </div>
      </div>
      <ModalBody>
        <FormGroup className="d-flex align-items-center">
          <InputGroup>
            <div className="input-group-prepend">
              <span className="input-group-text">{env('TENANT_PREFIX')}</span>
            </div>
            <Input value={tenantNumber} onChange={_ => setTenantNumber(_.target.value)} />
          </InputGroup>
          <div className="mx-2">-</div>
          <InputGroup>
            <div className="input-group-prepend">
              <span className="input-group-text">W</span>
            </div>
            <Input value={receivingRequestNumber} onChange={_ => setReceivingRequestNumber(_.target.value)} />
          </InputGroup>
        </FormGroup>
        {
          receivingRequest != null && (
            <div>
              <div className="mt-2 d-flex align-items-center">
                <Input type="number" className="text-right" step="1" value={quantity} onChange={_ => setQuantity(parseInt(_.target.value, 10))} style={{ width: 'auto' }} />
                <Button className="ml-2" onClick={onClickPrintBarcode.bind(null, false)} disabled={isPrinting || !(0 < quantity && quantity < 10000)}>
                  {isPrinting && <span className="fas fa-spin fa-spinner mr-1" />}
                  不明ラベル発行
                </Button>
              </div>
            </div>
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
};

